<!-- The inline listing row (HUBX-8480): the v2 row, the page's edited-row store and the shared
     write rules. Same geometry as before: Manufacturer and the live category pair sit on the
     line the read-only categories already occupied, so the row is no taller. -->
<form [formGroup]="fg" *ngIf="fg">
  <div class="item-wrapper"
    [class.disableddiv]="locked"
    [class._locked]="locked"
    [class._reduse]="!!reactivationHint"
    [class._archived]="isArchived"
    [class.error-border]="!!saveError"
    [class.selected]="selected"
    [class._select-active]="reactivationSelectable">

    <div class="item-select" *ngIf="reactivationSelectable">
      <label class="item-checkbox">
        <input type="checkbox" [checked]="reactivationChecked" (change)="toggleReactivation($event)">
        <i class="_icon"></i>
      </label>
    </div>

    <div class="item-logo-number">
      <div class="manufacturer-logo" (click)="openEditDetailedMode()">
        <img [src]="imageBaseUrl + manufacturerLink" width="50" height="50"/>
      </div>
    </div>

    <!-- part number and status -->
    <div class="item-part-number">
      <div class="item-info-title">
        Part Number
      </div>
      <div class="input-horizontal" [tooltip]="isAll ? sellerLabel : ''"
      (click)="copyText(row.item.vendorItemCode)">
        <input type="text" class="form-control disableMe" formControlName="vendorItemCode" [class.__invalid]="showInvalid('vendorItemCode')" [class.__conflict]="conflictOpen('vendorItemCode')">
      </div>

      <!-- status: the Edit modal's select - "You can set", then "Automatic" (disabled).
           Enabled by writableFields (status) alone. -->
      <div class="item-status">
        <select class="status-select" formControlName="skuStatus" [class.__conflict]="conflictOpen('skuStatus')"
          [class.__removed]="baseline.effectiveStatus === 'Removed'">
          <optgroup label="You can set">
            <option *ngFor="let option of assignableStatuses" [value]="option.value">{{ option.label }}</option>
          </optgroup>
          <optgroup label="Automatic">
            <option *ngFor="let option of automaticStatuses" [value]="option.value" disabled>{{ option.label }}</option>
          </optgroup>
        </select>
      </div>
    </div>

    <!-- description -->
    <div class="item-description">
      <!-- the title line carries Description's counter, on focus and while over the limit -->
      <div class="item-info-title __with-counter">
        Description
        <app-char-counter *ngIf="showDescriptionCounter" [length]="descriptionLength" [max]="descriptionMax"></app-char-counter>
      </div>
      <textarea class="form-control" formControlName="description" [class.__invalid]="showInvalid('description')" [class.__conflict]="conflictOpen('description')"
        (focus)="descriptionFocused = true" (blur)="descriptionFocused = false"></textarea>

      <!-- manufacturer + category pair (HUBX-8480): live, fed by /lookups, chained as in the popup -->
      <div class="item-categories">
        <!-- Native selects, as in the Edit popup: the lists are long, and a native select jumps to
             the option you start typing (app-dropdown offers no type-ahead). Enabled / disabled by
             the form itself (writableFields through applyWritability). -->
        <select class="item-categories__native item-categories__native--manufacturer" formControlName="manufacturerId" [class.__invalid]="showInvalid('manufacturerId')" [class.__conflict]="conflictOpen('manufacturerId')"
          [title]="manufacturerName" (focus)="openOptions('manufacturerId')" (mousedown)="openOptions('manufacturerId')">
          <option value="" disabled hidden>Manufacturer</option>
          <option *ngFor="let man of optionsFor('manufacturerId', lookups.manufacturers, 'id')" [value]="man.id">{{ man.name }}</option>
        </select>
        <span class="item-categories__sep" aria-hidden="true">&middot;</span>
        <select class="item-categories__native item-categories__native--main" formControlName="categoryMainId" [class.__invalid]="showInvalid('categoryMainId')" [class.__conflict]="conflictOpen('categoryMainId')"
          (focus)="openOptions('categoryMainId')" (mousedown)="openOptions('categoryMainId')">
          <option value="" disabled hidden>Category</option>
          <option *ngFor="let cat of optionsFor('categoryMainId', lookups.categories, 'categoryId')" [value]="cat.categoryId">{{ cat.name }}</option>
        </select>
        <ng-container *ngIf="subCategories.length">
          <span class="item-categories__sep" aria-hidden="true">&rsaquo;</span>
          <select class="item-categories__native" formControlName="categoryId" [class.__invalid]="showInvalid('categoryId')" [class.__conflict]="conflictOpen('categoryId')"
            (focus)="openOptions('categoryId')" (mousedown)="openOptions('categoryId')">
            <option value="" disabled hidden>Sub Category</option>
            <option *ngFor="let sub of optionsFor('categoryId', subCategories, 'categoryId')" [value]="sub.categoryId">{{ sub.name }}</option>
          </select>
        </ng-container>
      </div>

    </div>


    <div class="can-break">
        <div class="item-availability">
        <!-- available -->
        <div class="item-info-title">
          Available
        </div>
        <div class="input">
            <input type="number" class="form-control" formControlName="availability" [class.__invalid]="showInvalid('availability')" [class.__conflict]="conflictOpen('availability')"
              [class.empty-quantity-textbox]="role === 'SELLER' && !fg.controls.availability.value"
              appOnlyDigits>
        </div>
      </div>
      <!-- ETA: every role (2026-10-07); writableFields decides whether it can be typed in -->
      <div class="item-eta">
        <div class="item-info-title">ETA</div>
        <div class="input">
            <input type="text" class="form-control" formControlName="leadTimeDays" [class.__invalid]="showInvalid('leadTimeDays')" [class.__conflict]="conflictOpen('leadTimeDays')" mask="0*" [validation]="false">
        </div>
      </div>
    </div>


    <!-- MOQ -->
    <div class="item-price moq margin-left-24">
      <div class="item-info-title" [tooltip]="'Minimum Order Quantity'" containerClass="moqdq" placement="top">
        MOQ
      </div>
      <div class="input">
        <input [class.error]="fg.errors?.moqExceedsMxq"
        type="text" class="form-control" formControlName="moq" [class.__invalid]="showInvalid('moq')" [class.__conflict]="conflictOpen('moq')" mask="10*" [validation]="false" [patterns]="customPatterns">
      </div>
    </div>

    <!-- MXQ: every role (2026-10-07); writableFields decides whether it can be typed in -->
    <div class="item-price moq">
      <div class="item-info-title" [tooltip]="'Maximum Order Quantity'" containerClass="moqdq" placement="top">
        MXQ
      </div>
      <div class="input">
        <input [class.error]="fg.errors?.moqExceedsMxq"
        type="text" class="form-control" formControlName="mxq" [class.__invalid]="showInvalid('mxq')" [class.__conflict]="conflictOpen('mxq')" mask="0*"  [validation]="false">
      </div>
    </div>

    <!-- cost, price and updated -->
    <div class="align-right-block">
      <div class="item-half-block __top">
        <div class="item-cost" [class.red-border]="!!reactivationHint">
          <div class="item-info-title">
            Cost
          </div>
          <div class="input-price" [class.not-empty]="fg.controls.cost.value !== null">
            <input type="text" class="form-control" formControlName="cost" [class.__invalid]="showInvalid('cost')" [class.__conflict]="conflictOpen('cost')"
              prefix='$' mask="separator.2" thousandSeparator=",">
            <!-- Removed row: the cut that reactivates it, on hover (legacy parity) -->
            <div class="reduse-cost-tooltip" *ngIf="showReduceCost" [class.for-seller]="role === 'SELLER'">
              <div class="reduse-cost-body">
                <div class="reduse-cost-header">
                  <h3>0 items were sold within a week</h3>
                </div>
                <div class="reduse-cost-content">
                  <p>To activate listing, <br> you must reduce cost <br> by at least {{ reductionPercent }}%</p>
                  <div class="reduse-cost-content__ctrl">
                    <button type="button" class="btn" (click)="applyReactivationThreshold()">
                      <span>Reduce to {{ row.reactivationThreshold | CustomCurrency }}</span>
                    </button>
                  </div>
                </div>
                <div class="reduse-cost-footer">
                  <span>The above cost is the minimum requirement to activate the status</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="item-price" *ngIf="pricing">
          <div class="item-info-title">
            Price
          </div>
          <div class="input-price" [ngClass]="{'not-empty': fg.controls.unitPrice.value !== null}">
            <input type="text" class="form-control" formControlName="unitPrice" [class.__invalid]="showInvalid('unitPrice')" [class.__conflict]="conflictOpen('unitPrice')"
              [class.error]="fg.errors?.unitPriceBelowCost"
              prefix='$' mask="separator.2" thousandSeparator=",">
          </div>
        </div>
        <!-- DQ #1-3 after Cost / Price, where the Edit modal and the expanded row draw them
             (HUBX-8466): all three slots for ADMIN / VM, none for a Seller (dqSlots). -->
        <ng-container formArrayName="discountQtys">
          <div class="item-price item-dq" *ngFor="let tier of dqSlots; let i = index" [class.__first]="i === 0">
            <div class="item-info-title" [tooltip]="'Discount Quantity'" containerClass="moqdq" placement="top">
              DQ #{{i+1}}
            </div>
            <div class="input-group-vertical" [formGroupName]="i">
              <div class="input-qty">
                <input type="text" class="form-control" formControlName="fromQty" prefix='<' mask="0*" (blur)="checkPrefix(qtyInput)" #qtyInput
                  [class.__invalid]="showDqInvalid(tier, 'fromQty')">
              </div>
              <div class="input-price disc" [class.not-empty]="tier.controls.price.value !== null">
                <input type="text" class="form-control"
                   formControlName="price" prefix='$' mask="separator.2" thousandSeparator="," (blur)="checkPrefix(tierPrice)" #tierPrice
                   [class.__invalid]="showDqInvalid(tier, 'price')">
              </div>
            </div>
          </div>
        </ng-container>
      </div>
      <div class="item-half-block ctrls" [class.admin]="pricing">
        <div class="updated">
          <span>Updated</span>
          <span>{{row.lastUpdatedOn | date:'shortDate'}}</span>
        </div>
        <div class="bottom-icons-group control-btns">
          <a role="button" class="item-icon-btn clone has-item-btn-tooltip" (click)="triggerClone($event)">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="8.5" y="8.5" width="11" height="11" rx="2" stroke="#4586D5" stroke-width="2"/>
              <path d="M15.5 5.5H6.5C5.39543 5.5 4.5 6.39543 4.5 7.5V16.5" stroke="#4586D5" stroke-width="2" stroke-linecap="round"/>
            </svg>
            <div class="item-btn-tooltip">Clone</div>
          </a>
          <a role="button" class="item-icon-btn has-item-btn-tooltip"
            [class.vendor-item-updated]="isEdited"
            (click)="undoItemUpdates($event)" placement="bottom">
            <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24"><path d="m6.00421756 12c0 3.3145476 2.685161 6 5.99819244 6 3.3130315 0 5.9981925-2.6854524 5.9981925-6 0-2.93735818-2.1307842-5.42920384-4.9978674-5.90946034l-.3577692-.05992884v-3.01214526l.4814055.05980358c4.4775011.55622674 7.8736286 4.37074396 7.8736286 8.92173086 0 4.9716573-4.0279056 9-8.99759 9-4.96968431 0-8.99758993-4.0283427-8.99758993-9 0-2.08356377.71259734-4.052563 1.99325746-5.63828975l-1.39602921-1.39460219-.10570299-.10190197c-.06353372-.06205206-.11475278-.11449547-.16190711-.16674877-.21437519-.23755639-.33443822-.46158458-.33443822-.73417161 0-.53166627.43160298-.96428571.96413509-.96428571h5.35563658c.14451306 0 .28211456.01920102.44139649.09157803.32099494.14585869.52273864.45091876.52273864.87270768v5.35714286c0 .53154704-.43202033.96428573-.96413513.96428573-.32186896 0-.51778503-.1144239-.7985355-.39298086l-.23290517-.23937411-1.14870224-1.14942643c-.73244391 1.01204442-1.1354112 2.2226953-1.1354112 3.4960671z" fill="#191a19"/></svg>
            <div class="item-btn-tooltip">Undo</div>
          </a>
          <!-- Dimmed while a conflict is unresolved, the form refuses the edit, or the server
               refused it and it is unchanged since (HUBX-8466); the tooltip says which. -->
          <a role="button" class="item-icon-btn update has-item-btn-tooltip" (click)="updateSingleItem()"
          [class.vendor-item-updated]="canSave" [attr.aria-disabled]="!canSave">
            <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd">
              <path fill="#191a19" d="M21 6.285l-11.16 12.733-6.84-6.018 1.319-1.49 5.341 4.686 9.865-11.196 1.475 1.285z" />
            </svg>
            <div class="item-btn-tooltip">{{ saveTooltip }}</div>
          </a>
          <div class="item-archive-controls" *ngIf="mayArchive">
            <a role="button" class="item-archive-controls__btn restore has-item-btn-tooltip" (mouseenter)="tooltipMsg = 'Archived'"
            *ngIf="isArchived" (click)="restoreItem()">Restore</a>
            <a role="button" class="item-archive-controls__btn archive has-item-btn-tooltip"
            (mouseenter)="tooltipMsg = 'Archive'"
            (click)="archiveItem()"
            *ngIf="!isArchived">
              <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <g fill="#EB3B44" fill-rule="nonzero">
                    <polygon points="19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12"></polygon>
                  </g>
                </g>
              </svg>
            </a>
            <div class="item-btn-tooltip">{{tooltipMsg}}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="item-error-block" [class.__empty]="!hasBanner">
      <!-- The standing Removed-row line (the band's percent, HUBX-8494), beside the reduce-cost
           popup on Cost. The reactivation notice below replaces it once the typed cost brings
           the item back (HUBX-8476). -->
      <div *ngIf="reactivationHint" class="__reduse-cost">
        <img src="/assets/images/alert.svg" width="24px" height="24px" />
        <span>{{ reactivationHint }}</span>
      </div>

      <!-- what SAVE will do beyond what was typed: the popup's notices, in its amber
           (nothing failed, so never the red banner) -->
      <div class="item-save-notice col-md-12" *ngFor="let notice of notices">
        <span>{{ notice }}</span>
      </div>

      <!-- a 412 on this row's last save (HUBX-8478): the Edit modal's amber notice. Save stays
           blocked until the row is resolved in the resolve popup (HUBX-8466). -->
      <div class="item-conflict-line col-md-12" *ngIf="conflictNotice">
        <span>{{ conflictNotice }}</span>
        <button type="button" class="item-conflict-line__action" (click)="reviewConflict()">{{ reviewLabel }}</button>
      </div>

      <!-- the last save's failure, else the shared validation banner -->
      <div class="line-error col-md-12" *ngIf="errorLine">
        <img [src]="imageBaseUrl + '/assets/images/exclamation-mark.svg'" width="24px" height="24px" />
        <span>{{ errorLine }}</span>
      </div>

      <!-- the success mark (HUBX-8478): in the error's slot, a check rather than an
           exclamation so it reads without colour; it fades (the page clears it). -->
      <div class="line-saved col-md-12" *ngIf="showSaved" role="status">
        <svg width="24" height="24" viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="#2E9E6B"
          stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="10" stroke-width="2"/><path d="m7.5 12.5 3 3 6-6.5"/>
        </svg>
        <span>{{ savedText }}</span>
      </div>
    </div>
  </div>
</form>
